import { makeStyles } from '@material-ui/core'
import React, { useRef } from 'react'
import useElementOnScreen from '../../Utils/useIntersectionObserver'
import Text from '../Text'
import { PracticeHub } from '../../Themes/Images'

const integrationsStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    // paddingTop: 60,
    // paddingBottom: 120,
    marginBlock: 130,
    maxWidth: 1100,
    marginInline: 'auto',
    [theme.breakpoints.up(1921)]: {
      maxWidth: 1300,
    },
    [theme.breakpoints.down(1440)]: {
      maxWidth: 1000,
    },
    [theme.breakpoints.down(1100)]: {
      maxWidth: 900,
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: 700,
      marginBlock: 30
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: '100%',
      paddingInline: 16,
      paddingBlock: 40,
    },
  },
  integrationText: {
    width: 'fit-content',
    marginBottom: 68,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    [theme.breakpoints.down(760)]: {
      marginBottom: 32
    },
  },
  colorText: {
    background: 'linear-gradient(90deg, #90205D 0%, rgba(238, 67, 82, 0.97) 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
  },
  integrated: {
    marginBottom: 27
  },
  imgHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 30,
    [theme.breakpoints.down(1230)]: {
      // flexWrap: 'wrap',
      gap: 30,

    },
    [theme.breakpoints.down(760)]: {
      // flexWrap: 'wrap',
      gap: 30,
      maxWidth: 400,
      justifyContent: 'space-between'
    },
    [theme.breakpoints.down(400)]: {
      // flexWrap: 'wrap',
      gap: 15,
    },
  },
  svg: {
    height: '50px',
    width: '150px',
    [theme.breakpoints.down('xs')]: {
      width: '80px',
    },
  },
  svg1: {
    height: '70px',
    width: '170px',
    [theme.breakpoints.down('xs')]: {
      width: '80px',
    },
  },
  gensolve: {
    height: '50px',
    width: '150px',
    objectFit: 'contain',
    [theme.breakpoints.down('xs')]: {
      width: '80px',
    },
  },
  iconStyling: {
    // height: '50px', 
    // width: '200px',
    cursor: 'pointer',
    // marginLeft: '30px',
    // borderRight: '1px solid #EDEDED',
    paddingRight: 30,
    [theme.breakpoints.down(760)]: {
      width: 85
    }
  },
  iconStylingPH: {
    // height: '50px', 
    // width: '200px',
    cursor: 'pointer',
    // marginLeft: '30px',
    // borderRight: '1px solid #EDEDED',
    // paddingRight: 30,
    [theme.breakpoints.down(760)]: {
      width: 85
    }
  },

  iconStylingLast: {
    // height: '50px', 
    // width: '200px',
    cursor: 'pointer',
    // marginLeft: '30px',
    // borderRight: '1px solid #EDEDED',
    // paddingRight: 30
  }
}))

const Integrations = ({ getStarted }) => {
  const classes = integrationsStyles()
  const ref = useRef()
  const onScreen = useElementOnScreen(ref)

  return (
    <section ref={ref} className={classes.wrapper} style={{
      opacity: onScreen ? 1 : 0,
      translate: onScreen ? 'none' : '0 50px',
      transition: '1s ease-in-out',
    }}>
      <div className={classes.integrationText}>
        <Text weight='medium' size='h2'>Link Your Systems</Text>
        <Text size='body' style={{ textAlign: 'center' }}>Integrate easily with the tools you already use.</Text>
      </div>
      <div className={classes.imgHolder}>
        <div className={classes.iconStyling}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/websiteSEO/svg/cliniko.svg' alt='cliniko' className={classes.svg} id='icon'
            onClick={() => getStarted('https://www.cliniko.com/connected-apps/dataplayer/')} />
        </div>
        <div className={classes.iconStyling}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/website-sep9/other/Smaller%20-%20Colour.svg' alt='nookal' className={classes.svg1} id='icon'
            onClick={() => getStarted('https://www.nookal.com/releases/dataplayer-integration')} />
        </div>
        <div className={classes.iconStylingPH}>
          <img src={PracticeHub} alt='practiceHub' className={classes.gensolve} id='icon'
            onClick={() => getStarted('https://practicehub.io/')} />
        </div>
        <div className={classes.iconStyling}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/websiteSEO/svg/xero.svg' alt='xero' className={classes.svg} id='icon'
            onClick={() => getStarted('https://www.xero.com/')} />
        </div>
        <div className={classes.iconStyling}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/websiteSEO/img/gensolveLogo.png' alt='gensolve' className={classes.gensolve} id='icon'
            onClick={() => getStarted('https://www.gensolve.com/nz/')} />
        </div>
        <div className={classes.iconStyling}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/website-sep9/home/halaxy.svg' alt='halaxy' className={classes.gensolve} id='icon'
            onClick={() => getStarted('https://www.halaxy.com/')} />
        </div>
        <div className={classes.iconStylingLast}>
          <img src='https://dyl2njn37ytxk.cloudfront.net/website-sep9/home/googleSheets.svg' alt='google sheets' className={classes.gensolve} id='icon'
            onClick={() => getStarted('https://workspace.google.com/products/sheets/')} />
        </div>
      </div>
    </section>
  )
}

export default Integrations